"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import PlayButton from "../ui/playbutton";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export const VerticalMediumVideoHeadingNews = t0 => {
  const $ = _c(22);
  const {
    title: t1,
    imageSrc: t2,
    slug,
    imageMetadata
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95\u0BBE\u0BB5\u0BBF\u0BB2\u0BCD \u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF \u0BAA\u0BC6\u0BB1\u0BCD\u0BB1 \u0B95\u0BBE\u0B99\u0BCD\u0B95\u0BBF\u0BB0\u0BB8\u0BCD \u0B95\u0B9F\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0BBF\u0BA4\u0BBF\u0BB7\u0BCD \u0B95\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD \u0BB5\u0BBE\u0BB4\u0BCD\u0BA4\u0BCD\u0BA4\u0BC1 \u0BA4\u0BC6\u0BB0\u0BBF\u0BB5\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BBE\u0BB0\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const title = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const imageSrc = t4;
  const titleValue = title?.value || "";
  let t5;
  if ($[4] !== imageSrc?.value) {
    t5 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const imageSrcValue = t5;
  let t6;
  if ($[6] !== imageMetadata || $[7] !== imageSrc?.customClass || $[8] !== imageSrc?.hidden || $[9] !== imageSrcValue || $[10] !== titleValue) {
    t6 = !imageSrc?.hidden && <div><div className="relative w-full aspect-[16/9] overflow-hidden"><div className="absolute bottom-2 right-2 z-10"><PlayButton /></div><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[6] = imageMetadata;
    $[7] = imageSrc?.customClass;
    $[8] = imageSrc?.hidden;
    $[9] = imageSrcValue;
    $[10] = titleValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== title?.customClass || $[13] !== title?.hidden || $[14] !== titleValue) {
    t7 = !title?.hidden && <h3 className={`text-14-tamil-700 leading-[1.2] text-1B1B1B ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[12] = title?.customClass;
    $[13] = title?.hidden;
    $[14] = titleValue;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex flex-col overflow-hidden p-4 gap-4">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const content = t8;
  if (slug) {
    const t9 = `/${slug}`;
    let t10;
    if ($[19] !== content || $[20] !== t9) {
      t10 = <Link href={t9} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[19] = content;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    return t10;
  }
  return content;
};